// extracted by mini-css-extract-plugin
export default {"menu":"menu_menu__L48Nr","expanded":"menu_expanded__MplfR","toggleIcon":"menu_toggleIcon__1+KbW","logout":"menu_logout__f9P9H"};